import React from 'react';

const ApproachSection = () => (
  <section className="approach" id="approach" data-testid="approach-section">
    <div className="wrap">
      <div className="head">
        <span className="eyebrow">Our approach</span>
        <h2>We start with who needs to live there.</h2>
        <p>Then we find, prepare and run the property that meets that need, with the discipline of a major infrastructure programme.</p>
      </div>
      <div className="steps">
        <div className="step">
          <span className="n">01</span>
          <h3>Define the requirement</h3>
          <p>Who needs accommodation, where, for how long, and to what standard.</p>
        </div>
        <div className="step">
          <span className="n">02</span>
          <h3>Match the property</h3>
          <p>Source or take on residential and commercial property that fits the need.</p>
        </div>
        <div className="step">
          <span className="n">03</span>
          <h3>Make it ready</h3>
          <p>Mobilisation, refurbishment coordination, contractors and compliance, before anyone moves in.</p>
        </div>
        <div className="step">
          <span className="n">04</span>
          <h3>Run it well</h3>
          <p>Occupancy, maintenance coordination and performance oversight, every day it is in use.</p>
        </div>
      </div>
    </div>
  </section>
);

export default ApproachSection;
